import { createAsyncThunk } from "@reduxjs/toolkit";

import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { aboutStatsSectionApi } from "service/aboutStatsSectionApi";

export const getAboutStatsSection = createAsyncThunk(
  "getAboutStatsSection",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await aboutStatsSectionApi.getAboutStatsSection();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAboutStatsSection = createAsyncThunk(
  "updateAboutStatsSection",
  async ({ data }, { rejectWithValue, dispatch }) => {
    try {
      const { data: response } =
        await aboutStatsSectionApi.updateAboutStatsSection(data);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getAboutStatsSection());
      return response;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
